<template lang="pug">
.style(:class="{'overFlowHidden':modalShow}")
  #breadCrumb.container.d-flex.my-3
    router-link(to="/").mb-0.text-gray.text-decoration-none 首頁
    .mb-0.text-gray.mx-2 /
    router-link(:to="'/productDetail/' + categoryId").mb-0.text-gray.mx-2.categoryLink.text-decoration-none {{categoryName}}
    p.mb-0.text-gray.mx-2 /
    .mb-0.mx-2.categoryLink.text-decoration-none(@click="$router.push('/standard/' + productId)") {{`${productName}`}}
  .container
    p.pageTitle.text-center.mb-4.mb-md-5 挑選你喜愛的風格
    .row
      .col-12.col-md-6.mb-2.mb-md-0
        .d-flex.align-items-center.justify-content-center
          p.mb-0.mr-3 排列順序
          <select v-model="sortingKey" id="sortingKey" name="sortingKey" @change="changeSortingOrStyle()" class="select">
            <option value="2">最新上架優先</option>
            <option value="1">熱門程度優先</option>
          </select>
      .col-12.col-md-6
        .d-flex.align-items-center.justify-content-center
          p.mb-0.mr-3 風格分類
          <select v-model="styleKey" id="styleKey" name="styleKey" @change="changeSortingOrStyle()" class="select">
            <option v-for="styleClass in getStyleClass" :value="styleClass.styleId">{{styleClass.styleName}}</option>
          </select>
      hr.w-100.hr.mt-4.mb-5
    .row
      .col-md-3.col-6.mb-5(v-for="item in productItemRender" v-if="item.page_no === activePage").d-flex.justify-content-center(@click="modalShow = !modalShow; $store.state.openStyleModal = true; modalBigImg = item.imgcover; modalRightOne = item.img1; modalRightTwo = item.img2; editLink = item.editLink; templateName = item.templateName; specId = item.specId; sizeId = item.sizeId; productId = item.productId;")
        .card.rounded-0
          .imgBox
            img.card-img-top.rounded-0.img-fluid(:src="item.imgcover")
          .card-body
            h6.text-center.card-title.text-secondary {{item.templateName}}
    //- pagination
    .row.justify-content-center
      nav(aria-label='Page navigation example')
        ul.pagination
          li.page-item(v-if="activePage !== 1" @click="prev")
            .page-link(href='#' aria-label='Previous')
              span(aria-hidden='true') &laquo;
              span.sr-only Previous
          li.page-item(v-for="itm in pagination" @click="changePage(itm)")
            .page-link {{itm}}
          li.page-item(v-if="activePage !== pagination[pagination.length - 1]" @click="next")
            .page-link(href='#' aria-label='Next')
              span(aria-hidden='true') &raquo;
              span.sr-only Next
  //- 點擊圖片後顯示的lightbox
  //- 通用三張圖的lightbox
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 3" @click.stop="modalShow = !modalShow; $store.state.openStyleModal = false")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}}
      .d-flex.align-items-center
        .d-flex.justify-content-center.align-items-center.flex-column.coverImgBox
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalBigImg" style="width: auto; max-height: 500px;")
        .d-flex.flex-column.justify-content-center.align-items-center(style="width: 40%").h-50.w-100
          img.img-fluid(:src="modalRightOne" style="width: auto; max-height: 300px;")
        .d-flex.flex-column.justify-content-center.align-items-center(style="width: 40%").h-50.w-100
          img.img-fluid(:src="modalRightTwo" style="width: auto; max-height: 300px;")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- 通用一張圖的lightbox
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 1 " @click.stop="modalShow = !modalShow; $store.state.openStyleModal = false")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%")
          img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- 通用兩張圖的lightbox
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId !== 11 && categoryId !== 12 && categoryId !== 13 && categoryId !== 14 && categoryId !== 7 && categoryId !== 3 && categoryId !== 16" @click.stop="modalShow = !modalShow; $store.state.openStyleModal = false")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 95%")
          img.img-fluid(:src="modalBigImg"   style="max-width: 100%")
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 95%")
          img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- 以下為 按照產品客製
    //- lightbox for bag
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 5")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- lightbox for clothes
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 14")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- lightbox for puzzle
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 13")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- lightbox for redenv 紅包袋 有編輯提醒
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 12")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        button(@click="redenvModalShow = !redenvModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="redenvModalShow && templateImgCount === 2 && categoryId === 12")
    .border.border-dark.editModalBox.p-3
      p.modalTitle.mt-4.text-center 編輯提醒 <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="redenvModalShow = !redenvModalShow; $store.state.openRedenvModal = false">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-if="fullWidth > 900")
          .lightBoxImgBox(style="max-width:100%;" v-if="productId === 55")
            img.img-fluid(src="/static/img/edit55.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 56")
            img.img-fluid(src="/static/img/edit56.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 110")
            img.img-fluid(src="/static/img/edit110.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 111")
            img.img-fluid(src="/static/img/edit110.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 112")
            img.img-fluid(src="/static/img/edit110.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 113")
            img.img-fluid(src="/static/img/edit113.jpg" style="max-width: 100%")
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-else)
          .lightBoxImgBox(style="max-width:100%;" v-if="productId === 55")
            img.img-fluid(src="/static/img/edit55_mobile.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 56")
            img.img-fluid(src="/static/img/edit56_mobile.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 110")
            img.img-fluid(src="/static/img/edit110M.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 111")
            img.img-fluid(src="/static/img/edit110M.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 112")
            img.img-fluid(src="/static/img/edit110M.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 113")
            img.img-fluid(src="/static/img/edit113M.jpg" style="max-width: 100%")
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.my-2 開始製作
  //- 20231205 lightbox for thermos
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 13 && productId !== 11 && productId !== 65 && productId !== 66")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        button(@click="editThermosModalShow = !editThermosModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="editThermosModalShow && templateImgCount === 2 && productId !== 11 && productId !== 65 && productId !== 66")
    .border.border-dark.editModalBox.p-3
      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="editThermosModalShow = !editThermosModalShow; $store.state.openEditModal = false">×</button>
      br
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 60%" v-if="fullWidth > 900")
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(src="/static/img/edit_thermos.jpg" style="max-width: 100%")
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-else)
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(src="/static/img/edit_mobile_thermos.jpg" style="max-width: 100%")
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.mb-1 開始製作
  //- 2023/09/28 一張圖的lightbox for nb
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 11")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center(v-if="styleTitle") {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true">×</button>
      p.modalTitle.mb-4.ml-4.text-center(v-else) 情人節素材教學 <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true; styleTitle = !styleTitle; hiddenPageLastVideoBtn = false; hiddenPageNextVideoBtn = true; hiddenMakeVideoBtn = false">×</button>
      .d-flex.justify-content-center
        .lightBoxImgBox(style="max-width:100%;")
          <div id="carouselVideo" class="carousel slide" data-interval="false">
            <div class="carousel-inner">
              <div class="carousel-item active">
                .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%")
                  p 預覽
                  .lightBoxImgBox(style="max-width:65%;")
                    img.img-fluid(:src="modalRightOne" style="max-width: 100%")
              </div>
            </div>
          </div>
      .d-flex.justify-content-center.mt-5
        button(@click="editModalShow = !editModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="editModalShow && templateImgCount === 2 && categoryId === 11")
    .border.border-dark.editModalBox.p-3
      p.modalTitle.mt-4.text-center 編輯提醒 <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="editModalShow = !editModalShow; $store.state.openEditModal = false">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 90%")
          .lightBoxImgBox(style="max-width:100%;" v-if="productId === 51")
            <div id="carouselExampleIndicators" class="carousel slide" data-interval="false" v-if="fullWidth > 900">
              <div class="carousel-inner"  v-if="specId === 110 || specId === 111">
                <div class="carousel-item active">
                  <img src="/static/img/edit/edit51TA6_pc_01.jpg" class="d-block w-100" alt="edit51TA6_pc_01" v-if="sizeId === 330">
                  <img src="/static/img/edit/edit51T_pc_01.jpg" class="d-block w-100" alt="edit51T_pc_01" v-else>
                </div>
                <div class="carousel-item">
                  <img src="/static/img/edit/edit51T_pc_02.jpg" class="d-block w-100" alt="edit51T_pc_02">
                </div>
              </div>
              <div class="carousel-inner" v-else-if="specId === 108 || specId === 109">
                <div class="carousel-item active">
                  <img src="/static/img/edit/edit51LA6_pc_01.jpg" class="d-block w-100" alt="edit51LA6_pc_01" v-if="sizeId === 330">
                  <img src="/static/img/edit/edit51L_pc_01.jpg" class="d-block w-100" alt="edit51T_pc_01"  v-else>
                </div>
                <div class="carousel-item">
                  <img src="/static/img/edit/edit51L_pc_02.jpg" class="d-block w-100" alt="edit51T_pc_02">
                </div>
              </div>
              <a class="carousel-control-prev btn btn-primary btnEdit" href="#carouselExampleIndicators" role="button" data-slide="prev" v-show="hiddenPageLastBtn" @click="unHiddenBtn"> 上一頁
              </a>
              <a class="carousel-control-next btn btn-primary btnEditNext" href="#carouselExampleIndicators" role="button" data-slide="next" v-show="hiddenPageNextBtn" @click="hiddenBtn"> 下一頁
              </a>
            </div>
            <div id="carouselExampleIndicators" class="carousel slide" data-interval="false" v-else>
              <div class="carousel-inner"  v-if="specId === 110 || specId === 111">
                <div class="carousel-item active">
                  <img src="/static/img/edit/edit51TA6_mobile_01.jpg" class="d-block w-100" alt="edit51TA6_mobile_01" v-if="sizeId === 330">
                  <img src="/static/img/edit/edit51T_mobile_01.jpg" class="d-block w-100" alt="edit51T_mobile_01" v-else>
                </div>
                <div class="carousel-item">
                  <img src="/static/img/edit/edit51T_mobile_02.jpg" class="d-block w-100" alt="edit51T_mobile_02">
                </div>
              </div>
              <div class="carousel-inner" v-else-if="specId === 108 || specId === 109">
                <div class="carousel-item active">
                  <img src="/static/img/edit/edit51LA6_mobile_01.jpg" class="d-block w-100" alt="edit51LA6_mobile_01" v-if="sizeId === 330">
                  <img src="/static/img/edit/edit51L_mobile_01.jpg" class="d-block w-100" alt="edit51L_mobile_01" v-else>
                </div>
                <div class="carousel-item">
                  <img src="/static/img/edit/edit51L_mobile_02.jpg" class="d-block w-100" alt="edit51L_mobile_02">
                </div>
              </div>
              <a class="carousel-control-prev btn btn-primary btnEdit" href="#carouselExampleIndicators" role="button" data-slide="prev" v-show="hiddenPageLastBtn" @click="unHiddenBtn"> 上一頁
              </a>
              <a class="carousel-control-next btn btn-primary btnEditNext" href="#carouselExampleIndicators" role="button" data-slide="next" v-show="hiddenPageNextBtn" @click="hiddenBtn"> 下一頁
              </a>
            </div>
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 52")
            <div id="carouselExampleIndicators" class="carousel slide" data-interval="false" v-if="fullWidth > 900">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img src="/static/img/edit/edit52_pc_01.jpg" class="d-block w-100" alt="edit52_pc_01">
                </div>
                <div class="carousel-item">
                  <img src="/static/img/edit/edit52_pc_02.jpg" class="d-block w-100" alt="edit52_pc_02">
                </div>
              </div>
              <a class="carousel-control-prev btn btn-primary btnEdit" href="#carouselExampleIndicators" role="button" data-slide="prev" v-show="hiddenPageLastBtn" @click="unHiddenBtn"> 上一頁
              </a>
              <a class="carousel-control-next btn btn-primary btnEditNext" href="#carouselExampleIndicators" role="button" data-slide="next" v-show="hiddenPageNextBtn" @click="hiddenBtn"> 下一頁
              </a>
            </div>
            <div id="carouselExampleIndicators" class="carousel slide" data-interval="false" v-else>
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img src="/static/img/edit/edit52_mobile_01.jpg" class="d-block w-100" alt="edit52_mobile_01">
                </div>
                <div class="carousel-item">
                  <img src="/static/img/edit/edit52_mobile_02.jpg" class="d-block w-100" alt="edit52_mobile_02">
                </div>
              </div>
              <a class="carousel-control-prev btn btn-primary btnEdit" href="#carouselExampleIndicators" role="button" data-slide="prev" v-show="hiddenPageLastBtn" @click="unHiddenBtn"> 上一頁
              </a>
              <a class="carousel-control-next btn btn-primary btnEditNext" href="#carouselExampleIndicators" role="button" data-slide="next" v-show="hiddenPageNextBtn" @click="hiddenBtn"> 下一頁
              </a>
            </div>
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 53")
            <img src="/static/img/edit/edit53_pc_01.jpg" class="d-block w-100 img-fluid" alt="edit53_pc_01" v-if="fullWidth > 900">
            <img src="/static/img/edit/edit53_mobile_01.jpg" class="d-block w-100 img-fluid" alt="edit53_pc_02" v-else>
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 33")
            <img src="/static/img/edit/edit33_pc_01.jpg" class="d-block w-100 img-fluid" alt="edit33_pc_01" v-if="fullWidth > 900">
            <img src="/static/img/edit/edit33_mobile_01.jpg" class="d-block w-100 img-fluid" alt="edit33_pc_02" v-else>
      .d-flex.justify-content-center.mt-5(v-if="productId !== 53 || productId !== 33")
        a(:href="editLink" @click="StartMaking" v-show="hiddenMakeBtn").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking" v-if="productId === 53 || productId === 33").btn.btn-primary.btnInPage.text-decoration-none.startEdit.mb-1 開始製作
  //- 20240215 lightbox for 85 envelope
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 16 && productId === 85")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        button(@click="editEnvModalShow = !editEnvModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="editEnvModalShow && templateImgCount === 2 && productId === 85")
    .border.border-dark.editModalBox.p-3
      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="editEnvModalShow = !editEnvModalShow; $store.state.openEditModal = false">×</button>
      br
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 60%" v-if="fullWidth > 900")
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(src="/static/img/env_edit.jpg" style="max-width: 100%")
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-else)
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(src="/static/img/env_edit_mobile.jpg" style="max-width: 100%")
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.mb-1 開始製作
  //- 20240215 lightbox for 86 folder
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 16 && productId === 86")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        button(@click="editFolderModalShow = !editFolderModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="editFolderModalShow && templateImgCount === 2 && productId === 86")
    .border.border-dark.editModalBox.p-3
      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="editFolderModalShow = !editFolderModalShow; $store.state.openEditModal = false">×</button>
      br
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 60%" v-if="fullWidth > 900")
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(src="/static/img/folder_edit.jpg" style="max-width: 100%")
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-else)
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(src="/static/img/folder_edit_mobile.jpg" style="max-width: 100%")
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.mb-1 開始製作
  //- 20240215 lightbox for 87 paper folder
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 16 && productId === 87")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- 20240222 lightbox for 88 pen
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 16 && productId === 88")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- 20240215 lightbox for 89 stickynote
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 16 && productId === 89")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- 20240215 lightbox for 90 lanyard
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 16 && productId === 90")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        button(@click="editFolderModalShow = !editFolderModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="editFolderModalShow && templateImgCount === 2 && productId === 90")
    .border.border-dark.editModalBox.p-3
      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="editFolderModalShow = !editFolderModalShow; $store.state.openEditModal = false">×</button>
      br
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 60%" v-if="fullWidth > 900")
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(src="/static/img/lanyard_edit.jpg" style="max-width: 100%")
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-else)
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(src="/static/img/lanyard_edit_mobile.jpg" style="max-width: 100%")
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.mb-1 開始製作
  //- 20240221 lightbox for 10
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 3 && productId === 10")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- 20240221 lightbox for 30
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 3 && productId === 30")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit 開始製作
  //- 20231115 act bag
  //- .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 5")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        button(@click="editModalShow = !editModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="editModalShow && templateImgCount === 2 && categoryId === 5")
    .border.border-dark.editModalBox.p-3
      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="editModalShow = !editModalShow; $store.state.openEditModal = false">×</button>
      br
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 95%")
          .lightBoxImgBox(style="max-width:100%;")
            <iframe v-if="fullWidth > 640" width="835" height="600" src="https://www.youtube.com/embed/AyqGablMuaE?si=hIBYtG3pRNI9csr9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            <iframe v-else width="250" height="200" src="https://www.youtube.com/embed/AyqGablMuaE?si=hIBYtG3pRNI9csr9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.mb-1 開始製作
  //- 20231115 act mug
  //- .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 13")
    .border.border-dark.modalBox.p-3
      p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        button(@click="editModalShow = !editModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="editModalShow && templateImgCount === 2 && categoryId === 13")
    .border.border-dark.editModalBox.p-3
      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="editModalShow = !editModalShow; $store.state.openEditModal = false">×</button>
      br
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 95%")
          .lightBoxImgBox(style="max-width:100%;")
            <iframe v-if="fullWidth > 640" width="835" height="600" src="https://www.youtube.com/embed/AyqGablMuaE?si=hIBYtG3pRNI9csr9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            <iframe v-else width="250" height="200" src="https://www.youtube.com/embed/AyqGablMuaE?si=hIBYtG3pRNI9csr9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.mb-1 開始製作
    //- 20240627新增紙袋製作
  //-   .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 7 && productId === 106")
  //-   .border.border-dark.modalBox.p-3
  //-     p.modalTitle.mb-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openStyleModal = true">×</button>
  //-     .d-flex.justify-content-center
  //-       .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
  //-         p 預覽
  //-         .lightBoxImgBox(style="max-width:100%;")
  //-           img.img-fluid(:src="modalRightOne" style="max-width: 100%")
  //-     .d-flex.justify-content-center.mt-5
  //-       button(@click="editFolderModalShow = !editFolderModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  //- .lightBox.d-flex.justify-content-center.align-items-center(v-if="editFolderModalShow && templateImgCount === 2 && productId === 106")
  //-   .border.border-dark.editModalBox.p-3
  //-     <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="editFolderModalShow = !editFolderModalShow; $store.state.openEditModal = false">×</button>
  //-     br
  //-     .d-flex.justify-content-center
  //-       .d-flex.justify-content-center.align-items-center.flex-column(style="width: 60%" v-if="fullWidth > 900")
  //-         .lightBoxImgBox(style="max-width:100%;")
  //-           img.img-fluid(src="/static/img/colorpaperbag_edit.jpg" style="max-width: 100%")
  //-       .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-else)
  //-         .lightBoxImgBox(style="max-width:100%;")
  //-           img.img-fluid(src="/static/img/colorpaperbag_edit_mobile.jpg" style="max-width: 100%")
  //-     .d-flex.justify-content-center
  //-       a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.mb-1 開始製作
  //- 20240627新增紙袋製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="modalShow && templateImgCount === 2 && categoryId === 7" )
    .border.border-dark.modalBox.p-3(style="max-width: 90%; max-height: 90vh;")
      p.modalTitle.mb-4.ml-4.text-center {{templateName}} <button type="button" class="close" aria-hidden="true"  @click.stop="modalShow = !modalShow; $store.state.openRedenvModal = true">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 50%")
          p 預覽
          .lightBoxImgBox(style="max-width:100%;")
            img.img-fluid(:src="modalRightOne" style="max-width: 100%")
      .d-flex.justify-content-center.mt-5
        button(@click="redenvModalShow = !redenvModalShow").btn.btn-primary.btnInPage.text-decoration-none.startEdit 前往製作
  .lightBox.d-flex.justify-content-center.align-items-center(v-if="redenvModalShow && templateImgCount === 2 && categoryId === 7")
    .border.border-dark.editModalBox.p-3
      p.modalTitle.mt-4.text-center 編輯提醒 <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.stop="redenvModalShow = !redenvModalShow; $store.state.openRedenvModal = false">×</button>
      .d-flex.justify-content-center
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-if="fullWidth > 900")
          .lightBoxImgBox(style="max-width:100%;" v-if="productId === 106")
            img.img-fluid(src="/static/img/edit/colorpaperbag_edit.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 107")
            img.img-fluid(src="/static/img/edit/paperbag_edit.jpg" style="max-width: 100%")
        .d-flex.justify-content-center.align-items-center.flex-column(style="width: 100%" v-else)
          .lightBoxImgBox(style="max-width:100%;" v-if="productId === 106")
            img.img-fluid(src="/static/img/edit/colorpaperbag_edit_mobile.jpg" style="max-width: 100%")
          .lightBoxImgBox(style="max-width:100%;" v-else-if="productId === 107")
            img.img-fluid(src="/static/img/edit/paperbag_edit_mobile.jpg" style="max-width: 100%")
      .d-flex.justify-content-center
        a(:href="editLink" @click="StartMaking").btn.btn-primary.btnInPage.text-decoration-none.startEdit.my-2 開始製作
</template>

<script>
import { mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
export default {
  data () {
    return {
      fullWidth: document.body.clientWidth,
      modalShow: false,
      modalBigImg: null,
      modalRightOne: null,
      modalRightTwo: null,
      editLink: null,
      // changeStyleId: null,
      changeSortingKey: null,
      templateName: null,
      editModalShow: false,
      editThermosModalShow: false,
      redenvModalShow: false,
      editEnvModalShow: false,
      editFolderModalShow: false,
      editPaperFolderModalShow: false,
      editLanyardModalShow: false,
      specId: null,
      sizeId: null,
      // productId: null,
      hiddenPageLastBtn: false,
      hiddenPageLastVideoBtn: false,
      hiddenPageNextBtn: true,
      hiddenPageNextVideoBtn: true,
      hiddenMakeBtn: false,
      hiddenMakeVideoBtn: false,
      makeBtn: true,
      styleTitle: true,
      sortingKey: 2,
      styleKey: 0
    }
  },
  computed: {
    ...mapState({
      productItemRender: state => state.styleSearchModules.productItemRender,
      getStyleClass: state => state.styleSearchModules.getStyleClass,
      styleId: state => state.styleSearchModules.styleId,
      productName: state => state.styleSearchModules.productName,
      categoryName: state => state.styleSearchModules.categoryName,
      categoryId: state => state.styleSearchModules.categoryId,
      pagination: state => state.styleSearchModules.pagination,
      activePage: state => state.styleSearchModules.activePage,
      templateImgCount: state => state.styleSearchModules.templateImgCount,
      // 20240524
      specName: state => state.styleSearchModules.specName,
      size: state => state.styleSearchModules.size,
      // sizeId: state => state.styleSearchModules.sizeId,
      // specId: state => state.styleSearchModules.specId,
      productId: state => state.styleSearchModules.productId
    }),
    // 20240530使用mapFields修復productId問題
    ...mapFields(['productId'])
  },
  methods: {
    // dispatchChangeStyle () {
    //   let vm = this
    //   let changeStyleId = vm.changeStyleId
    //   vm.$store.dispatch('changeStyle', {changeStyleId})
    // },
    changeSortingOrStyle () {
      let vm = this
      let sortingKey = vm.sortingKey
      let styleKey = vm.styleKey
      vm.$store.dispatch('changeSorting', {sortingKey, styleKey})
    },
    changePage (itm) {
      this.$store.state.styleSearchModules.activePage = itm
    },
    prev () {
      this.$store.state.styleSearchModules.activePage -= 1
    },
    next () {
      this.$store.state.styleSearchModules.activePage += 1
    },
    // StartMaking () {
    //   window.fbq('trackCustom', 'StartMaking')
    // },
    hiddenBtn () {
      this.hiddenPageLastBtn = !this.hiddenPageLastBtn
      this.hiddenPageNextBtn = !this.hiddenPageNextBtn
      this.hiddenMakeBtn = !this.hiddenMakeBtn
    },
    unHiddenBtn () {
      this.hiddenPageLastBtn = !this.hiddenPageLastBtn
      this.hiddenPageNextBtn = !this.hiddenPageNextBtn
      this.hiddenMakeBtn = !this.hiddenMakeBtn
    },
    hiddenVideoBtn () {
      this.hiddenPageLastVideoBtn = !this.hiddenPageLastVideoBtn
      this.hiddenPageNextVideoBtn = !this.hiddenPageNextVideoBtn
      this.hiddenMakeVideoBtn = !this.hiddenMakeVideoBtn
      this.styleTitle = !this.styleTitle
    },
    unHiddenVideoBtn () {
      this.hiddenPageLastVideoBtn = !this.hiddenPageLastVideoBtn
      this.hiddenPageNextVideoBtn = !this.hiddenPageNextVideoBtn
      this.hiddenMakeVideoBtn = !this.hiddenMakeVideoBtn
      this.styleTitle = !this.styleTitle
    },
    closeVideoBtn () {
      this.hiddenPageLastVideoBtn = false
      this.hiddenPageNextVideoBtn = true
      this.hiddenMakeVideoBtn = false
    },
    getStyle () {
      let id = this.$route.params.id
      let specId = this.$route.params.specid
      let sizeId = this.$route.params.sizeid
      let sortingKey = 2
      this.$store.dispatch('getStyleDetailList', {id, specId, sizeId, sortingKey})
    },
    // 20240524 GTM start_edit 開始編輯
    StartMaking () {
      window.fbq('trackCustom', 'StartMaking')
      window.dataLayer.push({
        event: 'start_edit',
        categoryName: this.categoryName,
        productName: this.productName,
        productSpec: this.specName,
        productSize: this.size,
        templateName: this.templateName
      })
    }
  },
  async created () {
    const vm = this
    let id = vm.$route.params.id
    let specId = vm.$route.params.specid
    let sizeId = vm.$route.params.sizeid
    let sortingKey = 2
    await vm.$store.dispatch('getStyleDetailList', {id, specId, sizeId, sortingKey})
    await vm.$store.dispatch('getStyleClass', {id})
    // vm.changeStyleId = vm.styleId
    vm.changeSortingKey = sortingKey
    vm.hiddenPageLastBtn = false
    vm.hiddenPageNextBtn = true
    vm.hiddenMakeBtn = false
    // 2022/10/17, jamei, window.gtag_report_conversion(null, window.awConversionID, 'SybhCN6qlYcDELuN86Uo')
    // 202405 GTM specific_page_view
    window.dataLayer.push({
      event: 'specific_page_view',
      chinesePageTitle: `首頁 / ${this.categoryName} / ${this.productName} / ${this.specName} / ${this.size}`
    })
  }
}
</script>

<style lang="scss" scoped>
  $s14: 14px;
  $s20: 20px;
  $pageTitle: 24px;
  $serif: 'Noto Serif TC', serif;
  .categoryLink{
    cursor: pointer;
  }
  .pageTitle{
    font-family: $serif;
    font-size: $pageTitle;
    font-weight: bold;
  }
  .chooseStyleClass{
    border-width:3px;
    border-color: rgb(189, 186, 186);
  }
  .hr{
    border-width: 2px;
  }
  .card{
    max-height: 330px;
    max-width: 258px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover{
      .imgBox, .card-body{
        opacity: .5;
      }
    }
  }
  @media(max-width: 640px){
    .card{
      margin-bottom: 46px;
    }
  }
  // 裝訂方式 下方白色部分
  .card-body{
    height: 62px;
    box-sizing: border-box;
    h6{
      margin-bottom: 0;
      font-size: 18px;
    }
  }
  @media(max-width: 1024px){
    .card-body{
      height: 40px;
      padding:10px 0;
      font-size: 24px;
    }
    h6{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 0.6em;
    }
  }
  // 裝訂方式 相片部分
  .imgBox{
    max-height: 258px;
    max-width: 258px;
    overflow:hidden;
    img{
      max-width: 258px;
      max-height: 258px;
      transform:scale(1,1);
    }
  }
  // lightBox
  .lightBox{
    width: 100vw;
    background: rgba(0,0,0,.5);
    height: 100vh;
    position:fixed;
    top:0;
    left:0;
    right:0;
    z-index: 901;
    overflow-y: scroll;
    height: -webkit-fill-available;
    height: -moz-fill-available;
    height: -moz-available;
    height: fill-available;
  }
  // 頁面中的Btn樣式
  .btnInPage{
    border-radius: 5px;
    width: 203px;
    height: 39px;
    font-size: 21px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight:bold;
    .fa-chevron-right{
      margin-left: 37px;
    }
  }
  @media(max-width: 1024px){
    //.btnInPage{
      // width: 332px;
      //padding-left: 0;
    //}
    .try{
      display: flex;
      justify-content: center;
    }
  }
  .modalBox{
    background: #ededed;
    width: 60%;
    height: auto;
    overflow-y: scroll;
  }
  .modalVerticalBox{
    background: #ededed;
    width: 60%;
    height: auto;
    overflow-y: scroll;
  }
  .editModalBox{
    background: #ededed;
    width: 75%;
    height: auto;
    overflow-y: scroll;
  }
  .coverImgBox{
    width: 100%;
  }
  @media(max-width:651px){
    .modalBox{
      width: 95%;
    }
    .modalVerticalBox{
      width: 95%;
      height: 95%;
    }
    .editModalBox{
      background: #ededed;
      width: 95%;
    }
    .coverImgBox{
      width: 100%;
    }
  }
  .modalTitle{
    font-size: 24px;
    font-family:$serif;
    font-weight:bold;
  }
  .modal:nth-of-type(even) {
    z-index: 1052 !important;
}
.modal-backdrop.show:nth-of-type(even) {
    z-index: 1051 !important;
}
// 輪播器
.carousel-control-next,
.carousel-control-prev /*, .carousel-indicators */ {
    top: 102%;
}
.carousel-control-next {
  opacity:1;
}
.btnEdit {
  color: #fff;
  background-color: #5c87a6;
  border-color: #5c87a6;
  border-radius: 5px;
  width: 110px;
  height: 39px;
  font-size: 21px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  .fa-chevron-right {
    margin-left: 37px;
  }
}
.btnEditNext {
  color: #fff;
  background-color: #5c87a6;
  border-color: #5c87a6;
  border-radius: 5px;
  width: 110px;
  height: 39px;
  font-size: 21px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  .fa-chevron-right {
    margin-left: 37px;
  }
}
@media (min-width: 813px) {
  .btnEdit {
    &.startEdit {
      margin: 0 8px;
    }
  }
  .btnEditNext {
    &.startEdit {
      margin: 0 8px;
    }
  }
}
@media (max-width: 812px) {
  .btnEdit {
    width: 60px;
    height: 25px;
    font-size: 12px;
    margin-bottom: 10px;
    &.startEdit {
      width: 100%;
    }
  }
  .btnEditNext {
    width: 60px;
    height: 25px;
    font-size: 12px;
    margin-bottom: 20px;
    &.startEdit {
      width: 100%;
    }
  }
  .btnInPage{
    &.startEdit {
      width: 110px;
      height: 30px;
      font-size: 15px;
    }
  }
}
.xmascontainer {

position: relative;

padding-bottom: 56.25%;

padding-top: 30px;

height: 0;

overflow: hidden;

}

.xmascontainer iframe, .xmascontainer object, .xmascontainer embed {

position: absolute;

top: 0;left: 0;

width: 100%;

height: 100%;}
/*
.xmascontainer {
  position: relative;
  width: 70%;
  height: 0;
  padding-bottom: 56.25%;
  margin: 0 auto;
}
.xmasvideo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
*/
.select{
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/styleSearch.vue